import { environment } from '@/context/AppContext'
import { Button, Grid } from '@chakra-ui/react'
import { useSsoLogin } from 'BrokerTsLib/src/hooks'
import { Lock } from '../icons'

export const SSOLoginButtons = ({ returnUrl }: { returnUrl?: string }) => {
    const [isLoggingInOkHolding, loginOkHolding] = useSsoLogin('okholding', returnUrl)
    const [isLoggingInOkKlient, loginOkKlient] = useSsoLogin('okklient', returnUrl)
    const [isLoggingInOkKlientKeyCloak, loginOkKlientKeyCloak] = useSsoLogin('okklient-keycloak', returnUrl)

    const anyLoggingIn = isLoggingInOkHolding || isLoggingInOkKlient || isLoggingInOkKlientKeyCloak
    const showOkKlientKeyCloak = environment !== 'production'

    return <Grid
        sx={{ w: '100%', gap: 2, gridTemplateColumns: '1fr 1fr', justifyContent: 'center' }}
    >
        <Button colorScheme="primary" isLoading={isLoggingInOkHolding} isDisabled={anyLoggingIn} onClick={loginOkHolding}>
            <Lock />
            SSO OK HOLDING
        </Button>

        <Button variant="outline" isLoading={isLoggingInOkKlient} isDisabled={anyLoggingIn} onClick={loginOkKlient}>
            <Lock />
            OK KLIENT
        </Button>

        {showOkKlientKeyCloak && 
            <Button variant="outline" isLoading={isLoggingInOkKlientKeyCloak} isDisabled={anyLoggingIn} onClick={loginOkKlientKeyCloak}>
                <Lock />
                SSO OK KLIENT
            </Button>
        }
    </Grid>
}